import { Routes } from "@angular/router";

export const routes: Routes = [
    {
        path: "",
        loadChildren: () => import("./auth/auth.module").then(m => m.IdentityAuthModule)
    },
    {
        path: "",
        loadChildren: () => import("./mfa/mfa.module").then(m => m.IdentityMfaModule)
    },
    {
        path: "",
        loadChildren: () => import("./home/home.module").then(m => m.HomeModule)
    }
];
